import React from 'react';
import { Search, X } from 'lucide-react';
import { DATE_FILTERS, STAGES, T } from '../constants';

const selectStyle = {
  border: `1.5px solid ${T.line}`, borderRadius: 10, padding: '8px 11px',
  fontSize: 12.5, fontWeight: 600, color: T.body, background: T.surface,
  fontFamily: T.font, cursor: 'pointer', outline: 'none', minWidth: 120,
};

/** Compact filter bar above the board. */
export const JobToolbar = ({
  search, onSearch,
  stageFilter, onStageFilter,
  dateFilter, onDateFilter,
  hasFilters, onClear,
  total, showing,
}) => (
  <div style={{
    display: 'flex', alignItems: 'center', gap: 9, flexWrap: 'wrap',
    marginBottom: 14, fontFamily: T.font,
  }}>
    {/* Search */}
    <div style={{ position: 'relative', flex: '1 1 230px', minWidth: 190, maxWidth: 340 }}>
      <Search size={14} color={T.faint} style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }} />
      <input
        value={search}
        onChange={e => onSearch(e.target.value)}
        placeholder="Search applications…"
        aria-label="Search applications"
        style={{
          width: '100%', boxSizing: 'border-box',
          padding: '8px 11px 8px 32px',
          border: `1.5px solid ${T.line}`, borderRadius: 10,
          fontSize: 12.5, color: T.ink, fontFamily: T.font, outline: 'none',
          background: T.surface, transition: 'border-color 0.15s, box-shadow 0.15s',
        }}
        onFocus={e => { e.target.style.borderColor = T.brand; e.target.style.boxShadow = '0 0 0 3px rgba(239,29,40,0.10)'; }}
        onBlur={e => { e.target.style.borderColor = T.line; e.target.style.boxShadow = 'none'; }}
      />
    </div>

    <select value={stageFilter} onChange={e => onStageFilter(e.target.value)} aria-label="Filter by stage" style={selectStyle}>
      <option value="all">All stages</option>
      {STAGES.map(s => <option key={s.id} value={s.id}>{s.label}</option>)}
    </select>

    <select value={dateFilter} onChange={e => onDateFilter(e.target.value)} aria-label="Filter by date" style={selectStyle}>
      {DATE_FILTERS.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
    </select>

    {hasFilters && (
      <button
        type="button"
        onClick={onClear}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 5,
          border: `1.5px solid ${T.brandBorder}`, background: T.brandSoft,
          color: T.brandDark, borderRadius: 10, padding: '8px 12px',
          fontSize: 12.5, fontWeight: 700, cursor: 'pointer', fontFamily: T.font,
        }}
      >
        <X size={13} /> Clear
      </button>
    )}

    <span style={{ fontSize: 12, color: T.faint, marginLeft: 'auto', whiteSpace: 'nowrap' }}>
      {hasFilters ? `${showing} of ${total}` : `${total} application${total === 1 ? '' : 's'}`}
    </span>
  </div>
);
